import React, { ReactNode } from 'react'

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
  children?: ReactNode
  className?: string
}

export const Title = ({ level = 'p', children, className }: Props) => {
  const textSize = {
    h1: 'text-5xl',
    h2: 'text-4xl',
    h3: 'text-3xl',
    h4: 'text-2xl',
    h5: 'text-xl',
    h6: 'text-base',
    p: 'text-base'
  }

  const Heading = level

  return (
    <Heading className={`font-fira ${textSize[level.toString()]} ${className}`}>
      {children}
    </Heading>
  )
}
